/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Delete_Loading_TitleInputs */

const es_admin_users_delete_loading_title = /** @type {(inputs: Admin_Users_Delete_Loading_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminando usuario`)
};

const en_admin_users_delete_loading_title = /** @type {(inputs: Admin_Users_Delete_Loading_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting user`)
};

/**
* | output |
* | --- |
* | "Deleting user" |
*
* @param {Admin_Users_Delete_Loading_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_users_delete_loading_title = /** @type {((inputs?: Admin_Users_Delete_Loading_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Delete_Loading_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_users_delete_loading_title(inputs)
	return en_admin_users_delete_loading_title(inputs)
});
export { admin_users_delete_loading_title as "admin.users.delete.loading.title" }